import "./App.css";
import "@aws-amplify/ui-react/styles.css";

import { Amplify } from "aws-amplify";
import { AwsConfigAuth } from "./config/auth";
import { useEffect } from "react";
import { FooterWithCookieConsent, HeaderBar } from "@idwal/idwal-react-components";
import { setupTranslations } from "./services/translations";
import ReactGA from "react-ga4";
import { Navigate, Route, Routes } from "react-router-dom";
import { Logout } from "./components/Logout";
import { Register } from "./components/Register";
import { ResetPassword } from "./components/ResetPassword";
import { Login } from "./components/Login";
import { AuthRoute } from "./components/AuthRoute";
import { useCookies } from "react-cookie";
import { cookiePreferences } from "@idwal/idwal-utilities";
import { COOKIE_CONSENT } from "@idwal/idwal-utilities/lib/constants/cookies";
import { TermsAndConditions } from "./components/TermsAndConditions/TermsAndConditions";

Amplify.configure(AwsConfigAuth);
setupTranslations();

function App() {
    const TRACKING_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

    if (TRACKING_ID && TRACKING_ID !== undefined && TRACKING_ID !== "") {
        ReactGA.initialize(TRACKING_ID);
    }

    const [cookies, setCookie] = useCookies([COOKIE_CONSENT]);
    const cookieUtils = cookiePreferences(setCookie, cookies);

    useEffect(() => {
        ReactGA.send("pageview");
    }, []);

    return (
        <div className="flex flex-column min-h-screen">
            <div className="flex flex-column flex-grow-1">
                <HeaderBar logo="main" burgerMenu={false} />
                <section className="flex flex-column justify-content-center py-6 flex-grow-1 max-width-wrapper">
                    <Routes>
                        <Route path="/logout" element={<Logout />}></Route>
                        <Route
                            path="/register"
                            element={
                                <AuthRoute signOut>
                                    <Register />
                                </AuthRoute>
                            }
                        ></Route>
                        <Route
                            path="/reset-password"
                            element={
                                <AuthRoute signOut>
                                    <ResetPassword />
                                </AuthRoute>
                            }
                        ></Route>
                        <Route
                            path="/"
                            element={
                                <AuthRoute>
                                    <Login />
                                </AuthRoute>
                            }
                        ></Route>
                        <Route
                            path="/terms-and-conditions"
                            element={<TermsAndConditions />}
                        ></Route>
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                </section>
            </div>
            <FooterWithCookieConsent
                termsAndConditionsLink={"https://www.idwalmarine.com/terms-and-conditions/terms-of-use"}
                dataPrivacyLink={"Privacy@Idwalmarine.com"}
                cookiePolicyLink={"https://www.idwalmarine.com/terms/cookie-policy"}
                enableCookies={true}
                cookieUtils={cookieUtils}
            />
        </div>
    );
}

export default App;

